import React from "react";
import WrapperModule from "../WrapperModule";
import { Routes, Route } from "react-router-dom"
export function LazyLoadModules(props) {
	return (
		<><Routes>
			<Route path="*" element={<WrapperModule browserDetails={props?.browserDetails} siteConfig={props?.siteConfig} pagedata={props?.pageData?.modules} moduleCount={props?.pageData?.moduleCount} pathName={props?.pathName}/>} />
		</Routes>
		</>
	);
}
